import React, { useState } from "react";
import { toast } from "react-toastify";
import axios from "axios";

import Info from "../common/info";
import MenuGroupForm from "./menuGroupForm";
import { MenuGroupFormContainer } from "../../styled/setting";

const AddGroup = ({
  closeForm,
  toggleModal,
  menuGroup,
  setMenuGroup,
  openModal,
  closeModal,
  selectCompany,
  getMenuGroup,
  domain,
}) => {
  // 유효성 체크
  const validationCheck = () => {
    if (!menuGroup.name) {
      toast.error("상품명을 입력해주세요.");
      return false;
    }
    if (!menuGroup.products || !menuGroup.products.length) {
      toast.error("상품을 추가해주세요.");
      return false;
    }

    return true;
  };

  const handleSave = () => {
    if (!validationCheck()) return;

    openModal({
      type: "confirmation",
      title: "메뉴 그룹 추가",
      message: ["메뉴 그룹을 추가하시겠습니까?"],
      handleConfirm: handleSubmit,
    });
  };

  const handleSubmit = async () => {
    try {
      const url = "/erp/menuGroup/create";
      const body = {
        input: {
          name: menuGroup.name,
          cmpnyNo: selectCompany.value,
          menuPlatform: menuGroup.menuPlatform,
          productIds: (menuGroup?.products || []).map(({ id }) => Number(id)),
        },
      };

      const res = await axios.post(url, body);
      if (res.status === 200) {
        toast.success("메뉴 그룹이 등록되었습니다.", { toastId: "no-access" });
        await getMenuGroup();
        closeForm();
      }
    } catch (error) {
      console.log(error);
    } finally {
      closeModal();
    }
  };

  return (
    <MenuGroupFormContainer>
      <Info
        message="메뉴 그룹 추가"
        actions={[
          { label: "취소", func: closeForm, key: "cancel" },
          { label: "저장", func: handleSave, key: "add" },
        ]}
      />
      <MenuGroupForm
        menuGroup={menuGroup}
        setMenuGroup={setMenuGroup}
        toggleModal={toggleModal}
        selectCompany={selectCompany}
        domain={domain}
      />
    </MenuGroupFormContainer>
  );
};

export default AddGroup;
